import React, { useMemo, CSSProperties } from "react";
import { Form, FormItemProps } from "antd";

interface IFormItemProps {
  name?: string;
  label?: string;
  errors?: {
    [key: string]: string;
  };
  style?: CSSProperties;
  required?: boolean;
}

const FormItem: React.FC<IFormItemProps & FormItemProps> = ({
  name,
  errors,
  children,
  ...rest
}) => {
  const error = useMemo(() => {
    if (name && errors && errors[name]) {
      return errors[name];
    }
    return undefined;
  }, [errors, name]);

  return (
    <Form.Item
      name={name}
      validateStatus={error && "error"}
      help={error}
      {...rest}
    >
      {children}
    </Form.Item>
  );
};

export default FormItem;
